import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { useAccountCreationContext } from "@/components/signup/account-creation/hooks/account-creation-context";
import { Button } from "@/libraries/design/components/button/src/button";

export const InlineSubmit = () => {
    const intl = useIntl();
    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    const buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });

    return (
        <Button
            css={buttonCss}
            type="submit"
            disabled={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
            data-testid="embedded-signup-submit"
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event": "clicked",
                "data-event-component": "button",
                "data-event-container": "signup",
                "data-label": buttonText,
                "data-label-english": "Sign up"
            }}
        >
            {buttonText}
        </Button>
    );
};

const buttonCss = css({
    alignItems: "center",
    boxSizing: "border-box",
    display: "flex",
    fontFamily: "inherit",
    fontSize: "18px",
    fontWeight: 400,
    height: "48px",
    justifyContent: "center",
    minWidth: "auto",
    whiteSpace: "nowrap",
    width: "fit-content",
    [media.above.sm]: {
        margin: "-1px -1px -1px 0"
    },
    [media.below.sm]: {
        width: "100%",
        maxWidth: "100%"
    }
});
